mutation UserProfileEnable(
  $input: UserProfileEnableInput!
) {
  userProfileEnable(input: $input) {
   entitySelections
   {
    id
    rowTimestamp
   }
  }
}
